const TOOLTIPS_SELECTOR = '[data-toggle=tooltip]';

$(document).ready(function () {
    $(TOOLTIPS_SELECTOR).tooltip();
});